module.exports = __webpack_public_path__ + "static/media/baller logo.02045982.png";